import { Card, CardContent, CardActions, Typography, Chip, Stack, Button, Divider, Avatar, Box } from "@mui/material";
import { useState } from "react";

export type TaskBucketLabel = 'Projets' | 'Formation' | 'Technique';

export type TaskBucket = {
  label?: string;
  items: string[];      // sous-tâches / exemples
};

export type Experiences = {
  slug: string;
  title: string;
  since: string;
  excerpt: string;
  logo?: string;        // chemin image (ex: "/logos/irts.png")
  tasks: TaskBucket[];  // 3 blocs
  tech: string[];
  url?: string;
};

type Props = { p: Experiences };


export default function ExperienceCard({ p }: Props) {
  const [imgError, setImgError] = useState(false);

  return (
    <Card>
      <CardContent>
        <Stack direction="row" spacing={2} alignItems="center" sx={{ mb: 1 }}>
          {p.logo && (
            <Box
              component="img"
              src={p.logo}
              alt={p.title}
              sx={{
                width: 44,
                height: 44,
                objectFit: "contain",
                backgroundColor: "#fff",
                borderRadius: 1,
              }}
            />
          )}
          <Box>
            <Typography variant="h6">{p.title}</Typography>
            <Typography variant="body2" sx={{ opacity: 0.75 }}>
              {p.since}
            </Typography>
          </Box>
        </Stack>

        <Typography variant="body2" sx={{ mb: 1.5, opacity: 0.9 }}>
          {p.excerpt}
        </Typography>

        {/* Blocs Projets / Formation / Technique */}
        <Stack spacing={1.25}>
          {p.tasks.map((bucket) => (
            <Box key={bucket.label}>
              <Typography variant="subtitle2" sx={{ mb: 0.25 }}>
                {bucket.label}
              </Typography>
              <ul style={{ marginTop: 4, marginBottom: 8, paddingLeft: 18 }}>
                {bucket.items.map((t, i) => (
                  <li key={`${bucket.label}-${i}`}>
                    <Typography variant="body2">{t}</Typography>
                  </li>
                ))}
              </ul>
              <Divider sx={{ opacity: 0.2 }} />
            </Box>
          ))}
        </Stack>

        <Stack direction="row" spacing={1} useFlexGap flexWrap="wrap" sx={{ mt: 1 }}>
          {p.tech.map((t) => (
            <Chip key={t} label={t} size="small" />
          ))}
        </Stack>
      </CardContent>

      {p.url && (
        <CardActions>
          <Button href={p.url} target="_blank" rel="noreferrer">
            Voir
          </Button>
        </CardActions>
      )}
    </Card>
  );
}


